export enum CountriesQueryKeys {
  Countries = 'countries/',
}
